import { useAppSelector } from "../../hooks/StoreHooks";

export const useFirstOpenCheck = () =>
    useAppSelector((state) => state.firstOpenCheck.firstOpenCheck);